import {
  formatNormalNumber,
  createKpiTileItem,
  formatPercentageValue,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { buWithCompletedCycles, buWithCompletedCyclesDelta } =
      data.getPOReachMetrics;

    return createKpiTileItem(
      "BU's with Completed Cycles",
      formatNormalNumber(buWithCompletedCycles),
      buWithCompletedCyclesDelta !== null &&
        buWithCompletedCyclesDelta !== undefined
        ? {
            isPositiveValue: buWithCompletedCyclesDelta >= 0,
            text: formatPercentageValue(Math.abs(buWithCompletedCyclesDelta)),
            sideLabel: '',
            showArrow: Number(buWithCompletedCyclesDelta) !== 0,
          }
        : null
    );
  },
};
